import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function unsupportedSchemaFieldTypeMessage(field: SchemaField): string {
  return `Field "${field.name || 'unnamed'}" has unsupported type "${String(field.type)}".`
}
